/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { useTheme } from "../hooks/useTheme";

/**
 * Unified Page Container Component
 * Provides consistent layout and styling for all admin dashboard pages
 */
export default function PageContainer({ 
  title, 
  children, 
  maxW = "full",
  showTitle = true,
  ...props 
}) {
  const { isArabic, colors, dir, textAlign } = useTheme();

  return (
    <Box
      bg={colors.bg}
      minH="100vh"
      p={{ base: 4, md: 6, lg: 8 }}
      pb={{ base: 20, md: 6, lg: 8 }}
      textAlign={textAlign}
      dir={dir}
      {...props}
    >
      {showTitle && title && (
        <Heading
          mb={8}
          textAlign="center"
          color={colors.mainColor}
          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
          fontWeight="extrabold"
          letterSpacing="tight"
        >
          {title}
        </Heading>
      )}
      
      <Box maxW={maxW} mx="auto" pb={{ base: 2, md: 0 }}>
        {children}
      </Box>
    </Box>
  );
}

